<mat-drawer-container class="calendar-drawer-container" [hasBackdrop]="showCalendarSidebar" (backdropClick)="closeCalendarSidebar()">
  <mat-drawer-content>
    <div class="calendar-container" [class.content-blurred]="showCalendarSidebar">
      <div class="calendar-toolbar">
        <div class="toolbar-side toolbar-left">
          <button mat-icon-button (click)="prevMonth()" [disabled]="!canGoPrev()" aria-label="Vorheriger Monat">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <h2 class="month-title">{{ getCurrentMonthLabel() }}</h2>
          <button mat-icon-button (click)="nextMonth()" [disabled]="!canGoNext()" aria-label="Nächster Monat">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="toolbar-side toolbar-right">
          <button mat-icon-button (click)="goToToday()" aria-label="Heute">
            <mat-icon>today</mat-icon>
          </button>
          <button mat-icon-button (click)="toggleCalendarSidebar()" aria-label="Kalender auswählen">
            <mat-icon>tune</mat-icon>
          </button>
        </div>
      </div>

      <div class="weekdays-row">
        <div class="weekday" *ngFor="let day of daysOfWeek">{{ day }}</div>
      </div>

      <div class="month-grid">
        <div class="week" *ngFor="let week of weeks; let weekIndex = index">
          <div class="week-days">
            <button
              class="day-cell"
              *ngFor="let day of week; let dayIndex = index"
              [ngClass]="{
                'other-month': !day.currentMonth,
                today: isToday(day.date),
                selected: isSelected(day.date)
              }"
              (click)="selectDate(day.date)">
              <span class="day-number">{{ day.date.getDate() }}</span>
              <div class="day-overflow-dots" *ngIf="getOverflowDotTypes(weekIndex, dayIndex).length > 0">
                <span
                  class="overflow-dot"
                  *ngFor="let type of getOverflowDotTypes(weekIndex, dayIndex)"
                  [style.background-color]="getDotColor(type)"></span>
              </div>
            </button>
          </div>

          <div class="event-layers" *ngIf="visibleWeekEventRows[weekIndex]?.length">
            <div class="event-row" *ngFor="let row of visibleWeekEventRows[weekIndex]; let rowIndex = index" [style.top.px]="2 + rowIndex * 20">
              <button
                *ngFor="let segment of row"
                class="event-chip"
                [style.grid-column]="segment.startCol + ' / ' + (segment.endCol + 1)"
                [style.background-color]="getEventCalendarColor(segment.event)"
                (click)="editEvent(segment.event, $event)">
                {{ segment.event.name }}
              </button>
            </div>
          </div>
        </div>

        <div class="calendar-loading-overlay" *ngIf="isCalendarDataLoading">
          <div class="calendar-loading-spinner" aria-label="Kalender lädt"></div>
        </div>
      </div>
    </div>
  </mat-drawer-content>

  <mat-drawer class="calendar-filter-drawer" mode="over" position="end" [opened]="showCalendarSidebar">
    <div class="calendar-filter-body">
      <div class="calendar-filter-header">Kalender</div>
      <div class="calendar-filter-divider"></div>
      <div class="calendar-filter-list" *ngIf="calendarContainers.length > 0; else noCalendars">
        <div class="calendar-filter-row" *ngFor="let container of calendarContainers">
          <mat-checkbox
            class="calendar-filter-item"
            color="primary"
            [checked]="isCalendarSelected(container.calendar.id)"
            (change)="onCalendarVisibilityChange(container.calendar.id, $event.checked)">
            {{ container.calendar.name }}
          </mat-checkbox>
          <input
            class="calendar-color-picker"
            type="color"
            [value]="getCalendarColor(container.calendar.id)"
            (input)="onCalendarColorInput(container.calendar.id, $event)"
            aria-label="Kalenderfarbe" />
        </div>
      </div>

      <ng-template #noCalendars>
        <p class="calendar-filter-empty">Keine Kalender gefunden.</p>
      </ng-template>

      <div class="calendar-filter-footer">
        <button mat-raised-button color="primary" class="calendar-filter-close-btn" (click)="closeCalendarSidebar()">
          Schließen
        </button>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
